import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "../styles/noticiaDetalle.css";
import api from "../services/api";

const formatFecha = (isoDate) => {
  const fecha = new Date(isoDate);
  return fecha.toLocaleDateString("es-BO", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
};

export default function NoticiaDetalle() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [noticia, setNoticia] = useState(null);

  useEffect(() => {
    const fetchNoticia = async () => {
      const res = await api.get(`/eventos/${id}/`);
      setNoticia({
        titulo: res.data.titulo,
        categoria: res.data.categoria,
        contenido: res.data.noticia,
        imagen: res.data.imagen,
        fecha: formatFecha(res.data.updated_at),
      });
    };

    fetchNoticia();
  }, [id]);

  if (!noticia) return null;

  return (
    <div className="noticia-detalle-container">
      <button className="volver-btn" onClick={() => navigate(-1)}>
        ← Volver
      </button>

      <h1 className="titulo">{noticia.titulo}</h1>

      <div className="meta">
        <span className="categoria">{noticia.categoria}</span>
        <span className="fecha">{noticia.fecha}</span>
      </div>

      <img
        src={noticia.imagen}
        alt={noticia.titulo}
        className="imagen-principal"
      />

      <div className="contenido">
        {noticia.contenido}
      </div>
    </div>
  );
}
